var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1302 4.10618H38.0627V0.0629986H35.3489V4.10575L13.6507 4.10617V0.0629883H10.9369V4.10574L6.8694 4.10616C3.12929 4.10616 0.0881348 7.12889 0.0881348 10.8461V43.1967C0.0881348 46.9141 3.1294 49.9367 6.8694 49.9367H42.1298C45.8699 49.9367 48.9111 46.914 48.9111 43.1967V10.845C48.9111 7.13073 45.8702 4.10618 42.1302 4.10618ZM46.2004 43.1971C46.2004 45.4267 44.3761 47.2398 42.1328 47.2398H6.87027C4.62695 47.2398 2.80273 45.4266 2.80273 43.1971V17.5856H46.2015L46.2004 43.1971ZM46.2004 14.8919H2.79947V10.8461C2.79947 8.61646 4.62379 6.80337 6.86701 6.80337H10.9346V9.50055H13.6508V6.80337H35.3512V9.50055H38.065V6.80337H42.1325C44.3758 6.80337 46.2001 8.61657 46.2001 10.8461L46.2004 14.8919Z",
    fill: "url(#paint0_linear_506_326)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7865 31.066H27.2109C28.7073 31.066 29.9246 29.8565 29.9246 28.3688V22.9775C29.9246 21.4903 28.7077 20.2803 27.2109 20.2803H21.7865C20.2902 20.2803 19.0728 21.4898 19.0728 22.9775V28.3688C19.0758 29.8565 20.2927 31.066 21.7865 31.066ZM21.7865 22.9775H27.2109L27.2135 28.3688H21.7865L21.7865 22.9775Z",
    fill: "url(#paint1_linear_506_326)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70273 31.0662H14.1271C15.6235 31.0662 16.8409 29.8566 16.8409 28.369V22.9776C16.8409 21.4904 15.6239 20.2804 14.1271 20.2804H8.70273C7.20638 20.2804 5.989 21.49 5.989 22.9776V28.369C5.99198 29.8566 7.20888 31.0662 8.70273 31.0662ZM8.70273 22.9776H14.1271L14.1297 28.369H8.70267L8.70273 22.9776Z",
    fill: "url(#paint2_linear_506_326)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3486 31.066H40.7731C42.2694 31.066 43.4868 29.8565 43.4868 28.3688V22.9775C43.4868 21.4903 42.2698 20.2803 40.7731 20.2803L35.3486 20.2807C33.8523 20.2807 32.6349 21.4903 32.6349 22.9779V28.3693C32.6379 29.8565 33.8548 31.066 35.3486 31.066ZM35.3486 22.9775H40.7731L40.7756 28.3688H35.3486L35.3486 22.9775Z",
    fill: "url(#paint3_linear_506_326)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2266 44.5455H13.651C15.1474 44.5455 16.3647 43.3359 16.3647 41.8483V36.4569C16.3647 34.9697 15.1478 33.7597 13.651 33.7597H8.2266C6.73025 33.7597 5.51287 34.9693 5.51287 36.4569V41.8483C5.51287 43.3355 6.73025 44.5455 8.2266 44.5455ZM8.2266 36.4569H13.651L13.6536 41.8483H8.22654L8.2266 36.4569Z",
    fill: "url(#paint4_linear_506_326)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7865 44.5455H27.2109C28.7073 44.5455 29.9246 43.3359 29.9246 41.8483V36.4569C29.9246 34.9697 28.7077 33.7597 27.2109 33.7597H21.7865C20.2902 33.7597 19.0728 34.9693 19.0728 36.4569V41.8483C19.0758 43.3355 20.2927 44.5455 21.7865 44.5455ZM21.7865 36.4569H27.2109L27.2135 41.8483H21.7865L21.7865 36.4569Z",
    fill: "url(#paint5_linear_506_326)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3486 44.5455H40.7731C42.2694 44.5455 43.4868 43.3359 43.4868 41.8483V36.4569C43.4868 34.9697 42.2698 33.7597 40.7731 33.7597H35.3486C33.8523 33.7597 32.6349 34.9693 32.6349 36.4569V41.8483C32.6379 43.3355 33.8548 44.5455 35.3486 44.5455ZM35.3486 36.4569H40.7731L40.7756 41.8483H35.3486L35.3486 36.4569Z",
    fill: "url(#paint6_linear_506_326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_506_326",
    x1: -13.1754,
    y1: -2.38103,
    x2: 64.3081,
    y2: 59.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899845,
    stopColor: "#FBC016"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8b9968dcbf768b77622a1ef9e962888a.svg";
export { ForwardRef as ReactComponent };